import React from 'react';
import NavbarComponent from '../pages/Navbar';
import Footer from '../Footer';
import DetailsBanner from './DetailsBanner';
import CompanyInfo from './CompanyInfo';
import CommitmentSection from "../CommitmentSection";

const ServiceDetails = () => {
  return (
    <>
      <NavbarComponent />
      <DetailsBanner/>
      <CommitmentSection/>
      <CompanyInfo/>
      <Footer />
    </>
  );
};

export default ServiceDetails;
